const Form099TC = {
    stepName: {
        importantNotes: "重要事項",
        basicInfo: "基本信息",
        confirmation: "確認",
    },
    importantNotes: {
        tableTitle: "香港科學青苗獎提名表格",
        follow: "請留意以下部分：",
        num: {
            n1: "(1) ",
            n2: "(2) ",
            n3: "(3) ",
            n4: "(4) ",
            n5: "(5) ",
            n6: "(6) ",
        },
        serial: ["(a)", "(b)", "(c)", "(d)", "(e)", "(f)", "(g)", "(h)"],
        n1: "學校須通知學生及其家長／監護人，在比賽過程中，教育局及獲教育局授權的人士／團體將有機會進行拍攝或錄影，學生將有可能被拍攝或錄影。教育局可能會利用有關的照片或影片，以印刷或數碼形式作推廣用途。若學校或家長／監護人對有關安排有任何疑問，請電郵至 <a href='mailto:cdoge1@edb.gov.hk'>cdoge1@edb.gov.hk</a>。",

        n2: "參賽資格：",
        n21: "小學組：每所小學須提名3至5名小四至小六學生（當中最多可提名2名小六學生）；",
        n22: "中學組：每所中學須提名3至5名中一至中四學生（當中最多可提名2名中四學生）；",
        n23: "參賽名單一經提交，學校不可更改隊員名單。",

        n3: "請確認所輸入的資料正確無誤。有關資料，包括參賽作品將會用於相關得獎證書及本比賽的資料匯編上或其他教育用途。",
        n4: "參賽作品必須原創，不得侵犯版權。另外，學校不可以曾經參加過其他比賽的學生作品，參加香港科學青苗獎。",
        n5: "所有本比賽的相關資料，包括初賽、決賽的學生成績及活動，會上載本比賽網頁 <a href='http://www.edb.gov.hk/tc/BSA' target='_blank' rel='noreferrer'>http://www.edb.gov.hk/tc/BSA</a>。",
        n6: "參賽學校需要定期瀏覽本比賽網頁，查閱比賽的最新資訊。教育局不會再另行通知。",
    },
    sectionA: {
        title: "(A) 指導教師資料",
        teacherEngName: "教師姓名（英文）",
        teacherChName: "教師姓名（中文）",
        mobile: "手提電話號碼",
        email: "教師電郵地址",
        schoolEngName: "學校名稱（英文）",
        schoolChName: "學校名稱（中文）",
        schoolTel: "學校聯絡電話",
        schoolFax: "學校傳真號碼",
    },
    sectionB: {
        title: "(B) 參賽學生",
        engName: "姓名（英文）",
        chName: "姓名（中文）",
        form: "年級",
        formTips:
            "參賽資格：\n小學組：每所小學須提名3至5名小四至小六學生（當中最多可提名2名小六學生）；\n中學組：每所中學須提名3至5名中一至中四學生（當中最多可提名2名中四學生）；\n參賽名單一經提交，學校不可更改隊員名單。",
        formOption: {
            p4: "小四",
            p5: "小五",
            p6: "小六",
            s1: "中一",
            s2: "中二",
            s3: "中三",
            s4: "中四",
        },
        formPriOption: {
            p4: "小四",
            p5: "小五",
            p6: "小六",
        },
        formSecOption: {
            s1: "中一",
            s2: "中二",
            s3: "中三",
            s4: "中四",
        },
    },
    label: {
        selectedLanguage: "請用✓選擇參賽語言",
        signatureHead: "校長簽署",
        headName: "校長姓名",
        date: "日期",
        schoolChop: "校印",
        selectLangOption: {
            chinese: "中文",
            english: "英文",
        },
    },
    errorMsg: {
        faxMax12: "傳真號碼必須為最多12位數",
        selectOneSection: "請選擇同一參賽組別",
        selectListP: "每所小學須提名3至5名小四至小六學生",
        selectListS: "每所中學須提名3至5名中一至中四學生",
        selectMoreP: "最多可提名2名小六學生",
        selectMoreS: "最多可提名2名中四學生",
        selectLeastP: "每所小學須提名3至5名學生",
        selectLeastS: "每所中學須提名3至5名學生",
        selectLeast: "每所學校須提名3至5名學生",
    },
    formExpired: "有關香港科學青苗獎的學生提名經已截止。",
};
export default Form099TC;
